// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DNbL","footer":"styles_footer__3OoJd"};